export type DeliveryType = 'home_delivery' | 'domestic' | 'international';

export type FlowFilter = 'all' | 'medicine' | 'normal' | DeliveryType;

export interface FlowCounts {
  all: number;
  medicine: number;
  normal: number;
  home_delivery: number;
  domestic: number;
  international: number;
}

export const DELIVERY_TYPE_OPTIONS: ReadonlyArray<{
  value: DeliveryType;
  label: string;
  shortLabel: string;
  icon: string;
}> = [
  { value: 'home_delivery', label: 'Home Delivery', shortLabel: 'Home', icon: 'pi-home' },
  { value: 'domestic', label: 'Domestic', shortLabel: 'Domestic', icon: 'pi-truck' },
  { value: 'international', label: 'International', shortLabel: 'Intl', icon: 'pi-globe' },
];

export function resolveDeliveryType(item: any): DeliveryType | null {
  const raw = item?.delivery_type;
  if (raw === 'home_delivery' || raw === 'domestic' || raw === 'international') {
    return raw;
  }
  if (item?.is_courier) {
    return 'home_delivery';
  }
  return null;
}

export function hasDelivery(item: any): boolean {
  return resolveDeliveryType(item) !== null;
}

export function resolveAppointmentFlow(source: any): {
  deliveryType: DeliveryType | null;
  medicineCollection: boolean;
} {
  const deliveryType = resolveDeliveryType(source);
  if (deliveryType) {
    return { deliveryType, medicineCollection: false };
  }

  if (source?.medicine_collection || source?.is_medicine_collection) {
    return { deliveryType: null, medicineCollection: true };
  }

  return { deliveryType: null, medicineCollection: false };
}

export function deliveryTypeLabel(type: DeliveryType | null | undefined): string {
  if (!type) {
    return '';
  }
  return DELIVERY_TYPE_OPTIONS.find((option) => option.value === type)?.label ?? type;
}

export function deliveryTypeShortLabel(type: DeliveryType | null | undefined): string {
  if (!type) {
    return '';
  }
  return DELIVERY_TYPE_OPTIONS.find((option) => option.value === type)?.shortLabel ?? type;
}

export function deliveryBadgeIcon(type: DeliveryType | null | undefined): string {
  if (!type) {
    return '';
  }
  return DELIVERY_TYPE_OPTIONS.find((option) => option.value === type)?.icon ?? 'pi-send';
}

export function matchesFlowFilter(item: any, filter: FlowFilter): boolean {
  const delivery = resolveDeliveryType(item);
  const isMedicine = !!item?.medicine_collection;

  if (filter === 'all') {
    return true;
  }
  if (filter === 'medicine') {
    return isMedicine;
  }
  if (filter === 'normal') {
    return !isMedicine && !delivery;
  }
  return delivery === filter;
}

export function nextDeliveryType(current: DeliveryType | null): DeliveryType | null {
  if (!current) {
    return 'home_delivery';
  }
  const index = DELIVERY_TYPE_OPTIONS.findIndex((option) => option.value === current);
  if (index < 0 || index >= DELIVERY_TYPE_OPTIONS.length - 1) {
    return null;
  }
  return DELIVERY_TYPE_OPTIONS[index + 1].value;
}
